var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row alerts",class:{ 'alerts--hidden' : !_vm.showMessage }},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert",class:{ 'message-order-failed alert-danger' : _vm.error,
                   'message-order-succeed alert-success' : !_vm.error},domProps:{"innerHTML":_vm._s(_vm.messageName)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e8ef7bf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/errors.vue
// module id = 398
// module chunks = 0 1 2 3 4 5 6 7 8 10 32 40 44 70 84 88 97 121 365